import React from "react";
import PreSale from "../components/PreSale";
import video from "../assets/elephonkbg.mp4"

const Home = () => {
  return (
    <div
      id="home"
      className="bg-warm-yellow md:bg-transparent w-full flex flex-col md:flex-row md:h-screen items-center justify-center gap-16 md:gap-32 px-4 md:px-16 py-32 md:py-20"
    >
      <video autoPlay muted loop id="video-bg" className="fixed w-full top-0 hidden md:block -z-10">
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="md:basis-[60%] text-center md:text-left leading-tight">
        <div className="text-lg md:text-2xl uppercase">Welcome to</div>
        <div className=" text-[3em] md:text-[8em] uppercase  font-bold text- elephonkHeading ">
          Elephonk
        </div>
        <div className="text-sm md:text-2xl">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repudiandae
          non excepturi id sed rem corporis neque cumque voluptatem aliquid
          autem, vitae, recusandae unde! At mollitia id cumque atque consequatur
          fugit voluptates, nemo iusto aut labore architecto quo, ex voluptas
          adipisci!
        </div>
      </div>
      <div className="w-full md:basis-[40%]">
        <PreSale />
      </div>
    </div>
  );
};

export default Home;
